import React from 'react'
 import blankPage from '../assets/search/no-item.svg'

const Blanck404 = () => {
  return (
    <img className='w-50 h-75' src= {blankPage}alt="Blanck page" />
  )
}

export default Blanck404
